export var detailsBtn = {
  padding: '0.6em',
  '& > i': {
    margin: 0
  }
};
export var creditsTableWrap = {
  marginBottom: '2.5em',
  '& > div': {
    margin: 0
  }
};